import { render } from "./FinanceClaimsComponent.vue?vue&type=template&id=6b218b0c&scoped=true"
import script from "./FinanceClaimsComponent.vue?vue&type=script&lang=js"
export * from "./FinanceClaimsComponent.vue?vue&type=script&lang=js"

import "./FinanceClaimsComponent.vue?vue&type=style&index=0&id=6b218b0c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b218b0c"]])

export default __exports__